import React from 'react';
import {RadioButton} from 'primereact/radiobutton';
import './FilterRadioGroup.scss';

export interface RadioOption {
  label: string;
  value: string;
}

interface FilterRadioGroupProps {
  value: string;
  options: RadioOption[];
  onChange: (value: string) => void;
  name: string;
  className?: string;
}

const FilterRadioGroup: React.FC<FilterRadioGroupProps> = ({
  value,
  options,
  onChange,
  name,
  className = 'filter-radio-group'
}) => {
  return (
    <div className={className}>
      <div className="filter-radio-group__options">
        {options.map((option) => (
          <div key={option.value} className="filter-radio-group__option">
            <RadioButton
              inputId={`${name}-${option.value}`}
              name={name}
              value={option.value}
              onChange={(e) => onChange(e.value)}
              checked={value === option.value}
              className="filter-radio-group__radio"
            />
            <label 
              htmlFor={`${name}-${option.value}`} 
              className="filter-radio-group__label"
            >
              {option.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FilterRadioGroup;
